import Swiper from 'swiper';

export default class RecentWorkVideoSlider {
    constructor($el) {
        this.$el = $el;

        this.initSlider = this.initSlider.bind(this);

        this.initSlider();
    }

    initSlider() {
        new Swiper(this.$el, {
            spaceBetween: 20,
            loop: true,
            slidesPerView: 1.5,
            autoplay: {delay: 4000,},
            infinite: true,
            breakpoints: {
                600: {
                    slidesPerView: 2.5,
                },
                992: {
                    slidesPerView: 3.5,
                },
                1320: {
                    slidesPerView: 4.5,
                }
            }
        });
    }
}